import isEmpty from 'lodash/isEmpty';
import makeStyles from '@mui/styles/makeStyles';
import { supportsDvh } from '../../../commons/utils/css';

const styles = (theme) => ({

  dialogBox: ({ viewAnimation, initStyles }) => {
    
    function getHeight () {
      if (supportsDvh()) {
        return 'calc(95dvh)';
      }
      return 'calc(95vh - 100px)';
    }

    const styles = {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column !important',
      alignItems: 'center',
      width: '596px',
      // minHeight: '200px',
      height: '840px',
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 4px 4px 0px #00000040',
      zIndex: 10,
      opacity: 1,
      
      /*
      transition: 'all ease-in-out 350ms',
      webkitTransition: 'all ease-in-out 350ms',
      */

      padding: 0,
      overflow: 'hidden',
      borderRadius: '28px',
    
      position: 'relative',
      maxHeight: '95vh',
      
      webkitFlex: '0 0 auto',
      msFlex: '0 0 auto',
      flex: '0 0 auto',
     
      [theme.breakpoints.down('xs')]: {
        width: `calc(100% - 16px)`,
        minWidth: '320px',
        height: getHeight(),
      },
    };

    if (viewAnimation) {
      styles.opacity = 0;
    }
    
    if (!isEmpty(initStyles)) {
      styles.transform = initStyles.transform;
      styles.opacity = initStyles.opacity;
    }
 
    return styles;
  },

  dialogContent: ({ commonUIStyles }) => {
    const styles = {
      display: 'flex',
      width: '100%',
      ...commonUIStyles.contentSpace(),

      '&.MuiGrid-root': {
        
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflowY: 'auto',

      },
    };
    return styles;
  },

});

export default styles;
export const useStyles = makeStyles(styles);
